import { render } from "./CategoriasVue.vue?vue&type=template&id=6818b684&scoped=true"
import script from "./CategoriasVue.vue?vue&type=script&lang=js"
export * from "./CategoriasVue.vue?vue&type=script&lang=js"

import "./CategoriasVue.vue?vue&type=style&index=0&id=6818b684&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6818b684"]])

export default __exports__